
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class MylobyLoadMore extends Vue {

  @Prop({ default: false })
  public loading: boolean;

  @Prop({ default: 0 })
  public totalItems: number;

  @Prop({ default: 0 })
  public itemsLength: number;
}
